import {
  SET_CURRENT_USER,
  SET_LOGGEDIN_USER,
  GET_ALL_CUSTOMERS_SUCCESS,
  GET_CUSTOMER_DETAIL_SUCCESS,
} from '../actions/types'
import isEmpty from 'lodash/isEmpty'

/*const initialState = {
  isAuthenticated: false,
  user: {},
  profile: {},
  customers: [],
  customer: [],
}*/
const initialState = {
  isAuthenticated: false,
  user: {},
  profile: {},
  page: 0,
  total: 0,
  customers: [],
  customer: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.user),
        user: action.user,
      }
    case SET_LOGGEDIN_USER:
      return {
        ...state,
        profile: action.profile,
      }
      /*case GET_ALL_CUSTOMERS_SUCCESS:
        return {
          ...state,
          customers: action.customers,
        }*/
    case GET_ALL_CUSTOMERS_SUCCESS:
      return {
        ...state,
        page: action.page,
        total: action.total,
        customers: action.customers,
      }
    case GET_CUSTOMER_DETAIL_SUCCESS:
      return {
        ...state,
        customer: action.customer,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ducks/reducers/auth.js